import { render, staticRenderFns } from "./OthersPurchaseInputPivotComponent.vue?vue&type=template&id=ec3a88f0&"
import script from "./OthersPurchaseInputPivotComponent.vue?vue&type=script&lang=js&"
export * from "./OthersPurchaseInputPivotComponent.vue?vue&type=script&lang=js&"
import style0 from "./OthersPurchaseInputPivotComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports